
import BuySellYourHomeHeroSection from '../section';
import InfoBox from './info-box';
import routes from '@/constants/routes';

export default {
  name: 'SellYourHomeHeroSection',
  components: {
    InfoBox,
    BuySellYourHomeHeroSection,
  },
  props: {
    storeName: {
      type: String,
      required: true,
    },
    trackEvent: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      routes,
    };
  },
  computed: {
    content() {
      return this.$store.state[this.storeName].heroContent;
    },
  },
};
